import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type DAOExpanderContractFunctions1 =
  | []
  | [DAOExpanderContractFunctions]
  | [DAOExpanderContractFunctions, DAOExpanderContractEvents];
export type SWEvent = {
  event: DAOExpanderContractEventType;
  args: any;
}[];

export interface DAOExpanderContractFunctions {
  addActivitiesAddress: (
    activityAddr: string,
    actType: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  addToCoreTeam: (
    member: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  addURL: (_url: string, overrides?: CallOverrides) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  autIDAddr: (overrides?: CallOverrides) => Promise<string>;
  /**
   * Response type names are:
   *
   * actAddr: string
   * actType: number
   */
  getActivitiesWhitelist: (overrides?: CallOverrides) => Promise<[string, number]>;
  getAllMembers: (overrides?: CallOverrides) => Promise<string[]>;
  getCoreTeamWhitelist: (overrides?: CallOverrides) => Promise<string[]>;
  /**
   * Response type names are:
   *
   * contractType: number
   * daoAddress: string
   * metadata: string
   * commitment: number
   * market: number
   * discordServer: string
   */
  getDAOData: (overrides?: CallOverrides) => Promise<[number, string, string, number, number, string]>;
  getInteractionsAddr: (overrides?: CallOverrides) => Promise<string>;
  getInteractionsPerUser: (member: string, overrides?: CallOverrides) => Promise<number>;
  getURLs: (overrides?: CallOverrides) => Promise<string[]>;
  hasPassedOnboarding: (member: string, overrides?: CallOverrides) => Promise<boolean>;
  interactionAddr: (overrides?: CallOverrides) => Promise<string>;
  isActivityWhitelisted: (argument_0: string, overrides?: CallOverrides) => Promise<boolean>;
  isCoreTeam: (argument_0: string, overrides?: CallOverrides) => Promise<boolean>;
  isMemberOfExtendedDAO: (member: string, overrides?: CallOverrides) => Promise<boolean>;
  isMemberOfOriginalDAO: (member: string, overrides?: CallOverrides) => Promise<boolean>;
  isMemberOfTheDAO: (argument_0: string, overrides?: CallOverrides) => Promise<boolean>;
  isURLListed: (_url: string, overrides?: CallOverrides) => Promise<boolean>;
  join: (newMember: string, overrides?: CallOverrides) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  passOnboarding: (
    members: string[],
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  removeActivitiesAddress: (
    activityAddr: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  removeFromCoreTeam: (
    member: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  removeURL: (_url: string, overrides?: CallOverrides) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  setDiscordServer: (
    discordServer: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
  setMetadataUri: (
    metadata: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderContractEvents>}>;
}
export interface DAOExpanderContractEvents {
  events: SWEvent;
}

export enum DAOExpanderContractEventType {
  ActivitiesAddressAdded = "ActivitiesAddressAdded",
  ActivitiesAddressRemoved = "ActivitiesAddressRemoved",
  CoreTeamMemberAdded = "CoreTeamMemberAdded",
  CoreTeamMemberRemoved = "CoreTeamMemberRemoved",
  DiscordServerSet = "DiscordServerSet",
  MemberAdded = "MemberAdded",
  MetadataUriUpdated = "MetadataUriUpdated",
  OnboardingPassed = "OnboardingPassed",
  UrlAdded = "UrlAdded",
  UrlRemoved = "UrlRemoved"
}
